import React from 'react';
import './TopBar.css';
import { useTranslation } from 'react-i18next';
import flag_jp from '../assets/images/flag_jp.png'; 
import flag_us from '../assets/images/flag_us.png';

function importAll(r) {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}
const images = importAll(require.context('../assets/images', false, /\.(png|jpe?g|svg)$/));

function TopBar({ onNavigate, searchQuery, onSearchChange, songs, onSongSelect }) {
  const { t, i18n } = useTranslation();
  const [suggestions, setSuggestions] = React.useState([]);
  const searchContainerRef = React.useRef(null);

  React.useEffect(() => {
    if (searchQuery.length > 0) {
      const filtered = songs.filter(song =>
        song.title.en.toLowerCase().includes(searchQuery.toLowerCase()) ||
        song.title.ja.toLowerCase().includes(searchQuery.toLowerCase()) ||
        song.artist.en.toLowerCase().includes(searchQuery.toLowerCase()) ||
        song.artist.ja.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  }, [searchQuery, songs]);

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => { document.removeEventListener("mousedown", handleClickOutside); };
  }, [searchContainerRef]);

  const handleLanguageChange = () => {
    const newLang = i18n.language.startsWith('en') ? 'ja' : 'en';
    i18n.changeLanguage(newLang);
  };
  
  const handleSuggestionClick = (song) => {
    onSongSelect(song);
    onSearchChange('');
    setSuggestions([]);
  };

  // CORRECTED: Get only the base language code (e.g., 'en' from 'en-US')
  const baseLanguage = i18n.language.split('-')[0];

  return (
    <div className="top-bar">
      <div className="top-bar-left">
        <button onClick={() => onNavigate('home')} className="nav-button"><i className="fas fa-home"></i></button>
        <button onClick={() => onNavigate('artists')} className="nav-button-text">{t('navArtists')}</button>
      </div>

      <div className="search-container" ref={searchContainerRef}>
        <div className="search-bar"><i className="fas fa-search search-icon"></i><input type="text" placeholder={t('searchPlaceholder')} value={searchQuery} onChange={(e) => onSearchChange(e.target.value)} /></div>
        {suggestions.length > 0 && (
          <div className="search-suggestions">{suggestions.map(song => (
            <div key={song.id} className="suggestion-item" onClick={() => handleSuggestionClick(song)}>
              <img src={images[song.imageSrc]} alt={song.title[i18n.language]} className="suggestion-image" />
              <div className="suggestion-info">
                <span className="suggestion-title">{song.title[i18n.language]}</span>
                <span className="suggestion-artist">{song.artist[i18n.language]}</span>
              </div>
            </div>
          ))}</div>
        )}
      </div>
      
      <div className="user-controls">
        <button onClick={handleLanguageChange} className="language-button">
          <img src={baseLanguage === 'ja' ? flag_jp : flag_us} alt="Language flag" className="language-flag" />
          {/* CORRECTED: Display the base language code */}
          <span>{baseLanguage.toUpperCase()}</span>
        </button>
      </div>
    </div>
  );
}

export default TopBar;